'use client';

import { useSelector } from '@xstate/react';

import { AuthContext, User } from '@nhost/hasura-auth-js';
import { useMemo } from 'react';
import { State } from 'xstate';
import { useAuthInterpreter } from './useAuthInterpreter';

/**
 * Use `user` to get the user object.
 *
 * @example
 * ```ts
 * const { user } = useAuthenticatedUser();
 * ```
 *
 * @docs https://docs.nhost.io/reference/react/use-access-token
 */
export const useAuthenticatedUser = (): { user?: User | null, loading: boolean } => {
  const service = useAuthInterpreter();

  // Effect to update loading state only when it actually changes
  const loading = useSelector(
    service,
    useMemo(() => (state: State<AuthContext>) => state.tags.has('loading'), []),
  );

  return { loading, user: service.getSnapshot()?.context.user };
};
